import { IMapMarker, LatLng } from "../map-provider.interface";

export class NoneMarker implements IMapMarker {
    getPosition(): LatLng {
        return { lat: 0, lng: 0 };
    }

    remove(): void {
        // no-op
    }

    setPosition(_coords: LatLng): void {
        // no-op
    }

    onClick(_handler: () => void): void {
        // no-op
    }
}